import { render, staticRenderFns } from "./OAuthConsent.vue?vue&type=template&id=7eb823b4&scoped=true&"
import script from "./OAuthConsent.vue?vue&type=script&lang=js&"
export * from "./OAuthConsent.vue?vue&type=script&lang=js&"
import style0 from "./OAuthConsent.vue?vue&type=style&index=0&id=7eb823b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb823b4",
  null
  
)

export default component.exports